import { ComponentRef, Inject, Injectable, Renderer2, RendererFactory2, Type, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { GOOGLE_MAPS_API_KEY } from '../../services/config';
import { AuthFacade } from '../../store';

@Injectable({ providedIn: 'root' })
export class TrackingMapsRenderService {
  isGoogleMapApiScriptAppended$ = new BehaviorSubject<boolean>(false);
  private readonly renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2,
    private authFacade: AuthFacade,
  ) {
    if (!this.renderer) {
      this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    const mapSrc = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&callback=Function.prototype`;
    const isMapScriptAlreadyLoaded = !!this.document.head.querySelector(`[src="${mapSrc}"]`);

    if (isMapScriptAlreadyLoaded) {
      this.isGoogleMapApiScriptAppended$.next(true);
      return;
    }

    const scriptElement = this.renderer.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.charset = 'utf-8';
    scriptElement.src = mapSrc;
    scriptElement.onload = this.onLoad();

    this.authFacade.mapsPluginAccepted$.subscribe((accepted: boolean) => {
      if (!accepted) {
        return;
      }
      this.document.head.append(scriptElement);
    });
  }

  render<ComponentType>(
    viewContainerRef: ViewContainerRef,
    component: Type<ComponentType>,
  ): ComponentRef<ComponentType> {
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(component);
    componentRef.changeDetectorRef.markForCheck();
    return componentRef;
  }

  private onLoad(): () => void {
    return () => {
      this.isGoogleMapApiScriptAppended$.next(true);
    };
  }
}
